import { endOfDay, isAfter, isBefore, startOfDay } from "date-fns";
import { utcDate } from "src/utility/utilityFunctions";

import { OrderCalendarMonth } from "@models/OrderCalendarMonth";
import { UserRole } from "@models/UserRole";

import { OcmDateField } from "./types";

const orderWindowCloseDate: OcmDateField = "orderWindowCloseDate";

export function getOrderableEndDateField(role: string): OcmDateField {
  return (
    {
      "distributor-gallo": orderWindowCloseDate,
      "distributor-admin": orderWindowCloseDate,
      "distributor-orderer": orderWindowCloseDate,
      field1: orderWindowCloseDate,
      field2: "reviewCloseDate" as const,
    }[role] || ("purchasingCloseDate" as const)
  );
}

export function isOcmOrderableForRole(
  ocm: OrderCalendarMonth,
  role: UserRole
): boolean {
  const today = new Date();
  const endDateField = getOrderableEndDateField(role);
  return (
    isBefore(startOfDay(utcDate(ocm.orderWindowOpenDate)), today) &&
    isAfter(endOfDay(utcDate(ocm[endDateField])), today)
  );
}
